// PeptideVault v6.5 — Global application state

// ══════════════════════════════════════════════════════
// STATE
// ══════════════════════════════════════════════════════
let S = {
  tab: 'dashboard',
  docTab: 'all',
  selectedPeptide: null,
  modal: null,
  modalData: {},
  peptides: [], // SKU planning fields: vialStrengthMg (labeled strength), testedConcentration (COA result)
  documents: [],
  storageLocations: [],
  vaultPositions: [],       // v7.1 peptide-only physical B1/B2 map positions
  vaultAssignments: [],     // [{ id, positionId, peptideId, skuId, qty, holderType, assignedAt, confirmedAt }]
  vaultMovements: [],       // immutable peptide storage placement/movement history
  vaultReconciliations: [], // physical position confirmation history
  injections: [],
  healthData: [],       // [{ id, date, type, value, unit }]
  notes: [],            // [{ id, date, title, body, peptideId }]
  labResults: [],       // [{ id, date, panelName, markers:[{id,name,value,unit,refLow,refHigh}] }]
  supplements: [],      // timeOfDay: am | noon | pm | both | protocol
  users: [],            // [{ id, name, active, color, initials, notes }]
  peptideLibrary: [],   // [{ id, scientificName, customVialName, shortName, aliases, categories, active, includeInCards }]
  changeLog: [],        // [{ id, createdAt, entityType, entityId, action, description, userId }]
  customCategories: [], // [{ label, color, desc }] — user-created peptide categories
  refillLog: [],        // [{ id, suppId, name, amount, newTotal, date, at }] — supplement refill history
  injectionSupplies: [], // [{ id, name, category, description, lowStockThreshold, skus:[{id, barcode, vendor, lotNumber, sizeGauge, expiryDate, costPerUnit, reorderUrl, locations:[{locationId,qty}], transactions:[{id,type,qty,date,notes}]}] }]
  peptidePens: [],       // [{ id, brand, model, penUnits, needsSpacer, labelName, linkedPeptideIds:[], status, notes, createdAt, updatedAt }]
  vendors: [],           // [{ id, name, website, telegram, discord, whatsapp, email, notes }]
  cycleTimelines: [],
  blends: [],            // [{ id, name, userId, components:[{peptideId,peptideName,amountMg,amountUnit}], diluentType, diluentMl, doseVolumeMl, notes, createdAt }]    // [{ id, userId, importedAt, compounds:[{ name, linkedPeptideIds:[], entries:[{date,dosage}] }] }]
  suppFilter: 'all',
  suppTimeFilter: 'all',
  suppSort: 'alpha-asc',
  scheduleOpen: undefined,
  dashSubTab: 'today',
  calYear: new Date().getFullYear(),
  calMonth: new Date().getMonth(),
  hlSelected: [],       // selected peptide IDs for half-life viewer
  hlFromLast: true,     // single-dose: from last injection
  hlThreshold: 20,      // % threshold line
  hlCustomDate: '',     // custom injection date
  hlCustomTime: '',     // custom injection time
  hlMode: 'single',     // 'single' | 'calendar'
  hlWindowDays: 14,     // calendar mode: days to show back in time
  analyticsRange: '90', // legacy kept
  analyticsStart: '',   // custom start date YYYY-MM-DD
  analyticsEnd:   '',   // custom end date YYYY-MM-DD
  analyticsPeptide: 'all',   // for correlation view
  analyticsHealthMetric: 'weight', // for correlation view
  healthMetric: 'weight',
  healthRange:  '90',  // legacy
  healthStart:  '',
  healthEnd:    '',
  // Cloud credentials must be supplied per device. Never ship a usable sync
  // credential in browser-delivered source code.
  settings: { syncMode:'auto', customDir:'', dataDir:'', cloudUrl:'https://peptide-vault.pages.dev/api/data', cloudToken:'', anthropicKey:'', autoSyncEnabled:true, autoSyncIntervalMin:0 },
  lastSyncPull: null,   // ISO timestamp of last successful pull
  lastSyncPush: null,   // ISO timestamp of last successful push
  scanInput: '',
  scanMode: 'lookup',
  scanResult: null,
  scanQty: 1,
  calcVialMg: 5,
  calcWaterMl: 2,
  calcDoseMcg: 250,
  calcDoseUnit: 'mcg',
  calcSyringe: '100u',
  notifOpen: false,
  search: '',
  docSearch: '',
  toastTimer: null,
  // v6.0 Planning & Intelligence
  protocols: [],        // [{ id, name, userId, status:'active'|'upcoming'|'paused'|'completed', startDate, endDate, frequency, doseAmount, doseUnit, peptideId, peptideName, weekdays:[], phases:[], notes, createdAt }]
  scenarios: [],        // [{ id, name, baseProtocolId, changes:{}, notes, createdAt }]
  inventoryReservations: [], // ordered vial plans may include sequence, loadGroup, and penId
  regimenVersions: [],  // [{ id, suppId, effectiveDate, changes:{}, snapshot:{}, notes }]
  coas: [],             // [{ id, vendorId, lotIds:[], orderId, documentId, testLab, reportNo, testDate, results:[], notes, createdAt }]
  labMarkerDictionary: [], // [{ id, canonicalName, unit, aliases:[], category }] (BN16)
  savedViews: [],       // [{ id, module, name, filters:{}, sort:'', columns:[], density:'' }] (BN25)
  trash: [],            // [{ id, entityType, entityId, data:{}, deletedAt, deletedBy }] (BN27)
  snapshots: [],        // [{ id, date, label, protocolRefs:[], regimenVersionId, inventorySummary:{}, labRefs:[], notes }] (BN20)
  reportPresets: [],    // [{ id, name, sections:[], dateRange:{}, userId, labPanel }] (BN39)
  masterPlanRules: [],  // [{ id, type:'grouping'|'alias'|'ignoreAnomaly', compounds:[], alias:'', createdAt }]
  protocolDependencies: [], // [{ id, protocolId, relationType, relatedCompound, relatedProtocolId, offsetDays, description, source:'ai'|'manual' }]  // [{ id, type:'grouping'|'alias'|'ignoreAnomaly', compounds:[], alias:'', createdAt }]    // [{ id, name, sections:[], dateRange:{}, userId, labPanel }] (BN39)
  protocolRequirements: [], // reviewed finite requirements derived from authoritative protocol schedules
  mobilePickingSheets: [], // resumable phone picking sessions with item-level completion
  supplementLabelReviews: [], // reviewable OCR/AI label drafts and approved structured facts
  preparationBatches: [], // finalized pill-pack batches and reversible deductions
  labTrendConfig: {},   // { selectedMarkers:[], showCycleOverlay:true }
  _labCompareA: null,   // panel ID for lab comparison date A
  _labCompareB: null,   // panel ID for lab comparison date B
  dataQualityDismissed: [], // dismissed DQ item IDs
  _dashboardUser: '',
  _cmdPaletteOpen: false,
  _schemaVersion: 6,    // v9 preparation and label-intelligence domains
  _syncRevisions: {},   // per-domain cloud revisions persisted locally; never uploaded as a sync domain
  _syncSnapshotRevision: '', // committed atomic cloud generation revision
  _syncSnapshotBaseline: null, // last committed atomic snapshot used for three-way merges
  _syncTombstones: {}, // explicit per-domain record deletions, retained across devices
  _syncBaseline: null,  // last known cloud records per domain for automatic three-way reconciliation
  _syncPendingOps: {},  // local upsert/delete operations waiting to reach the cloud
  _syncDeviceId: '',    // stable local installation identifier; contains no personal data
  _debugLog: [],        // [{ ts, level, code, message }] (BN46) — in-memory only, not synced
  _environmentSensorStatus: { state:'idle' }, // live Govee status; credential remains server-side
  _densityMode: 'comfortable', // 'comfortable' | 'compact' (BN48)
  _aiPrivacy: { peptides:true, inventory:true, protocols:true, health:false, labs:false, ice:false, notes:false, documents:false }, // (BN41)
}

export {
  S
}
